import { useSyncExternalStore } from "react";
import { subscribe, getSnapshot, isLocal } from "@/lib/offline/engine";

export const useOffline = () => useSyncExternalStore(subscribe, getSnapshot);

export const useIsLocal = (uid) => {
  useOffline();
  return isLocal(uid);
};
